// Возвращает даты для проверок у ГУРВ
import { addMonths, format, parse, subMonths } from 'date-fns';
import { ru } from 'date-fns/locale';

// Получение частей даты для проверок у ГУРВ
export const extractDatePartsGURV = (date: string) => {
  const parsedDate = parse(date, "dd.MM.yyyy", new Date());

  const creatingDay = +format(parsedDate, "d", { locale: ru });
  const creatingMonth = +format(parsedDate, "M", { locale: ru });

  const currentDate = new Date();

  // Получаем предыдущий и следующий месяцы
  const previousMonthNumber = +format(subMonths(currentDate, 1), "M");
  const nextMonthNumber = +format(addMonths(currentDate, 1), "M");

  const currentMonthNumber = +format(currentDate, "M");
  const currentDay = +format(currentDate, "d");

  return { creatingDay, creatingMonth, currentMonthNumber, previousMonthNumber, nextMonthNumber, currentDay };
}